import { OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import componentStyles from './pc-featured-grid.css.lit';
import globalStyles from './pc-featured-grid.lightDom.css.lit';
import '../pc-icon/pc-icon';

import { AdoptedStyleSheets } from '@phase2/outline-adopted-stylesheets-controller';

/**
 * Featured Grid component
 * @element pc-featured-grid
 * @slot - This element has a default slot
 */
@customElement('pc-featured-grid')
export class PCFeaturedGrid extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];

  adoptedStylesheets: AdoptedStyleSheets;

  isMobile: boolean;

  @property({ type: Boolean, reflect: true, attribute: 'pin-featured' })
  pinFeatured: boolean;

  connectedCallback() {
    super.connectedCallback();

    this.adoptedStylesheets = new AdoptedStyleSheets(globalStyles);
    this.addController(this.adoptedStylesheets);

    const maxWidthScreen = 1024;
    this._mobileMode(maxWidthScreen);
  }

  updated() {
    if (this.pinFeatured) {
      const featuredItem = this.querySelectorAll('pc-teaser-card')[0];
      if (this.isMobile) {
        featuredItem.removeAttribute('size');
      } else {
        featuredItem.setAttribute('size', 'large');
      }
    }
  }

  render(): TemplateResult {
    return html`
      <div class="featured-grid">
        <div class="grid-list">
          <slot name="grid-item"></slot>
        </div>
      </div>
    `;
  }

  _mobileMode(width: number) {
    const maxMobileWidth = width - 1;
    const mediaQuery = `(max-width: ${maxMobileWidth}px)`;
    const mediaQueryList = window.matchMedia(mediaQuery);
    // Set initial value to isMobile
    this.isMobile = mediaQueryList.matches;

    // update isMobile value only when screen width is crossing maxMobileWidth (1024)
    mediaQueryList.addEventListener('change', event => {
      this.isMobile = event.matches;
      this.requestUpdate();
    });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-featured-grid': PCFeaturedGrid;
  }
}
